import * as Factory from 'factory.ts'
import faker from 'faker'

import { type ApplicationStatus } from '../../models'

export const ApplicationStatusMock =
  Factory.Sync.makeFactory<ApplicationStatus>({
    billing_info: {},
    expiry_date: Factory.each(() => faker.date.future().toISOString()),
    trial_mode: true,
    lock_mode: false,
  })
